module.exports = __webpack_public_path__ + "static/media/shrinkSidebar.66f6a5c2.svg";